module.exports = __webpack_public_path__ + "files/5722bd4270f84d4cab15e1b56d66377e.png";